<template>
  <div class="container mb60 mt30">
    <div class="row">
      <div
        class="col-lg-3 col-xs-3"
        v-for="item in icon_list"
        :key="item.id"
        @click="pageLink(item.id)"
      >
        <div class="icon-item">
          <div class="icon-image">
            <img :src="item.icon_image" />
          </div>
          <div class="icon-name">{{ item.name }}</div>
          <div class="icon-tip hidden-xs">快速注册 便捷操作</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["icon_list"],
  methods: {
    pageLink(id) {
      //console.log(id)
      switch (id) {
        case 1:
          // uni.navigateTo({
          // 	url:'../../pages/companyregister/companyregister'
          // })
          this.$router.push({
            path: "companyregister"
          });
          break;
        case 2:
          this.$router.push({
            path: "agency"
          });
          break;
        case 3:
          this.$router.push({
            path: "logoregister"
          });
          break;
        case 4:
          this.$router.push({
            path: "knowledge"
          });
          break;
        case 5:
          this.$router.push({
            path: "license"
          });
          break;
        case 6:
          this.$router.push({
            path: "services"
          });

          break;
        case 7:
          this.$router.push({
            path: "news"
          });

          break;
        case 8:
          this.$router.push({
            path: "medical"
          });

          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.col-lg-3,
.col-xs-3 {
  padding: 0 0.15rem;
}
.icon-item {
  width: 100%;
  height: 2.46rem;
  background: #ffffff;
  box-shadow: 0px 0.04rem 0.15rem 0px rgba(19, 149, 255, 0.11);
  border-radius: 0.12rem;
  margin: 0.18rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  .icon-image {
    width: 0.82rem;
    height: 0.82rem;
    margin-bottom: 0.2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .icon-name {
    font-size: 0.24rem;
    line-height: 0.33rem;
    margin-bottom: 0.05rem;
    @media (max-width: 991px) {
      font-size: 0.26rem;
    }
  }
  .icon-tip {
    font-size: 0.18rem;
    line-height: 0.25rem;
    color: #5e5e66;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: -0.03rem;
    left: 50%;
    transform: translate(-50%, 0);
    width: 0rem;
    height: 0.08rem;
    background: #1395ff;
    border-radius: 0.07rem;
    //transition: 0.5s all cubic-bezier(0.46, 1, 0.23, 1.52);
  }

  &:hover {
    &::after {
      //   width: 0.9rem;
      //   left: 50%;
      width: 0.9rem;
      -webkit-transition: width 0.5s;
      transition: width 0.5s;
    }
  }
}
@media (max-width: 991px) {
  .icon-item {
    height: auto;
    box-shadow: 0px 0 0 0px rgba(19, 149, 255, 0.11);
    margin: 0 0 0.18rem 0;
    .icon-image {
      width: 0.7rem;
      height: 0.7rem;
      margin-bottom: 0.14rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexicon.vue